import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { styled } from '@mui/material';
import toggle from '../../../../_assets/js/layout/base/aside.js';
import { useAppAliasIntlFormatter } from '@/app/hooks/formatFeatureName';
import { usePermissions } from '@/app/hooks/usePermissions';
import { shouldRenderSubMenuItem } from './asideUtils.js';

function getMenuItemActive(location, url) {
  return location.pathname === url ? ' menu-item-active menu-item-open ' : '';
}

function SubMenuList({ subMenu = [], ctx, can, onMouseEnter, onMouseLeave, menuBackground, style }) {
  const location = useLocation();
  const formatMessage = useAppAliasIntlFormatter();
  const { canAny } = usePermissions();

  return (
    <>
      {subMenu.map(sub => {
        if (!shouldRenderSubMenuItem(sub, ctx, can, canAny)) return null;

        const alertNumber = sub.getAlertNumber ? sub.getAlertNumber(ctx, can) : 0;

        return (
          <li
            key={sub.id}
            id="kt_aside_toggle"
            onClick={() => {
              toggle.getOffcanvas().hide();
            }}
            className={`menu-item ${getMenuItemActive(location, sub.route)}`}
            aria-haspopup="true"
            role="menuitem"
          >
            <NavLink
              className="menu-link"
              to={sub.route || '/'}
              style={{
                padding: sub.isSubMenu ? '9px 0px 9px 40px' : '9px 0px 9px 25px',
                background: menuBackground(sub, true)
              }}
              onMouseEnter={e => onMouseEnter(e, 'submenu', sub)}
              onMouseLeave={e => onMouseLeave(e, 'submenu', sub)}
            >
              <span
                className="menu-text font-weight-bold"
                style={{
                  color: location.pathname === sub.route ? style?.subFocusColor : style?.subColor
                }}
                onMouseEnter={e => onMouseEnter(e, 'subfont', sub)}
                onMouseLeave={e => onMouseLeave(e, 'subfont', sub)}
              >
                {formatMessage({ id: sub.id })}
              </span>

              {!!alertNumber && <NotificationIcon>{alertNumber}</NotificationIcon>}
            </NavLink>
          </li>
        );
      })}
    </>
  );
}

const NotificationIcon = styled('div')(() => ({
  backgroundColor: 'red',
  padding: 4,
  width: 20,
  height: 20,
  borderRadius: 50,
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  color: 'white',
  margin: '4px 10px 0 0'
}));

export default SubMenuList;
